import * as React from "react";

const FavoriteGame = favoriteGame;

export class FavoriteGames extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedFavoriteId: null
    };
    this.selectGame = this.selectGame.bind(this);
  }
  public render() {
    const { favoriteGames, games } = this.props;
    const { selectedFavoriteId } = this.state;
    const list = Object.keys(favoriteGames).map((key: any, i: number) => {
      const fav = favoriteGames[key];
      return (
        <FavoriteGame
          key={key}
          description={fav.description}
          game={games[fav.gameId]}
          isSelected={key == selectedFavoriteId}
          showMoreClick={() => this.selectGame(fav.key)}
          hideClick={() => this.selectGame(null)}
        />
      );
    });
    return (
      <>
        <div className="favorite-games">{list}</div>
      </>
    );
  }

  private selectGame(favoriteGameId: string | null) {
    this.setState({ selectedFavoriteId: favoriteGameId });
  }
}

function favoriteGame({
  game,
  description,
  showMoreClick,
  hideClick,
  isSelected
}: any) {
  return (
    <div className="favorite-game">
      <div className="title-and-art">
        <div className="title">
          <span>{game.title}</span>
        </div>
        <span className="year-and-platform">
          {game.year} - {game.platform}
        </span>
        <img className="game-art" src={game.artUrl} alt="" />
      </div>
      {!isSelected && (
        <div className="note">
          <span className="note-preview">"{description.substr(0, 50)}..."</span>
          <span className="show-more" onClick={showMoreClick}>
            Show more
          </span>
        </div>
      )}
      <span className="full-note-placeholder">
        {isSelected && (
          <div className="favorite-game-note">
            <div>{description}</div>
            <div className="hide-full-note">
              <span onClick={hideClick}>Hide</span>
            </div>
          </div>
        )}
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Profile/FavoriteGames.tsx